module.exports = __webpack_public_path__ + "img/pic6_bg.405a7e7.png";